import React from 'react';

function fmt(value, digits = 2, suffix = '') {
  if (value == null || value === '') return '—';
  const number = Number(value);
  const unit = suffix === 'pct' ? '个百分点' : suffix;
  return Number.isFinite(number) ? `${number.toFixed(digits)}${unit}` : '—';
}

function confidenceTone(value) {
  return value === 'medium_high' ? 'positive' : value === 'low' ? 'warn' : 'neutral';
}

const ACTION_LABELS = { buy: '买入', add: '加仓', hold: '持有', reduce: '减仓' };

export default function PerformanceTrendStrip({ trend }) {
  if (!trend) return null;
  if (!trend.available) {
    return <div className="perf-trend-empty"><strong>{trend.state_label || '样本不足'}</strong><p>{trend.summary}</p></div>;
  }

  return (
    <div className={`perf-trend-panel trend-${trend.state}`}>
      <div className="perf-trend-head">
        <div>
          <span>RECENT STATE · 近期状态</span>
          <h4>{trend.state_label}</h4>
          <p>{trend.summary}</p>
        </div>
        <div className={`perf-trend-confidence tone-${confidenceTone(trend.confidence)}`}>
          <span>判断可信度</span><strong>{trend.confidence_label}</strong><small>{trend.basis_label}</small>
        </div>
      </div>

      <div className="perf-trend-metrics">
        {(trend.metrics || []).map((item) => (
          <div className={`signal-${item.signal > 0 ? 'up' : item.signal < 0 ? 'down' : 'flat'}`} key={item.key}>
            <span>{item.label}</span>
            <strong>{fmt(item.previous, item.unit === 'pct' ? 1 : 2, item.unit)} <em>→</em> {fmt(item.recent, item.unit === 'pct' ? 1 : 2, item.unit)}</strong>
            <small>{item.verdict}</small>
          </div>
        ))}
      </div>

      <div className="perf-trend-evidence">
        <div>
          <span>同类交叉观察</span>
          <strong>{trend.peer_corroboration?.available ? trend.peer_corroboration.label : '同类历史样本不足'}</strong>
          <p>{trend.peer_corroboration?.available
            ? (trend.peer_corroboration.items || []).map((item) => `${item.metric} ${item.delta_percentile > 0 ? '+' : ''}${item.delta_percentile}个百分点`).join(' · ')
            : '当前结论仅基于产品自身净值前后窗口。'}</p>
        </div>
        <div className={trend.anomaly_caution ? 'has-caution' : ''}>
          <span>异常日影响</span>
          <strong>{trend.anomaly_caution ? '已下调可信度' : '未触发集中度降级'}</strong>
          <p>{trend.anomaly_caution || '异常日仅作复核线索，不直接改变趋势方向。'}</p>
        </div>
      </div>

      <div className="perf-trend-actions">
        {Object.entries(ACTION_LABELS).map(([key, label]) => (
          <div key={key}><span>{label}</span><p>{trend.action_impact?.[key]}</p></div>
        ))}
      </div>
      <p className="perf-trend-method">{trend.method}</p>
    </div>
  );
}
